// cleanup_hoc_to_hooks_LOGIN_WORKFLOW
// cleanup_class_to_function_LOGIN_WORKFLOW
// cleanup_convert_to_typescript_file_LOGIN_WORKFLOW

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSecureData, setSecureData } from '@mob/mobile';
import classnames from 'classnames';
import jsCookie from 'js-cookie';
import { withRouter } from 'react-router-dom';

import { withStyles, withTheme } from '@glu/theming';
import Switch from '@glu/switch-react';
import Alert from '@glu/alerts-react';

import { unsubscribeComponent } from 'components/utils/util';
import Slide from 'components/transitions/Slide';
import Modal from 'components/modal/Modal';
import SecurityChallenge from 'components/securityChallenge/SecurityChallenge';
import DeviceChallenge from 'components/deviceChallenge/DeviceChallenge';
import ChallengeManager from 'components/challengeManager/ChallengeManager';
import { AppConfigContext } from 'components/appConfig/AppConfig';
import { login } from 'api/user/service';
import { getSystemPublicOption } from 'api/config/service';
import { rememberDevice } from 'api/deviceChallenge/service';
import { setCurrentUser } from 'logic/store/authentication/actions';
import { LocaleShape, LocaleDefaultProps } from 'api/locale/props';
import { ALERTVARIATIONS, WORKSPACES, HEADERS, SYSTEM_OPTIONS } from 'constants.js';

import LoginHelpMessage from './LoginHelpMessage.tsx';
import styles from './LoginForm.styles';

const dummyCust = 'dummyCust';
const dummyPassword = 'dummyPassword';
const dummyUser = 'dummyUser';

const { SHOW_FORGOT_PASSWORD_OPTION } = SYSTEM_OPTIONS;

const subscriptions = {
  getSystemOption: null
};
export class LoginFormComponent extends Component {
  constructor(props) {
    super(props);
    this.passwordRef = React.createRef();
    this.state = {
      errorMessage: '',
      customerCode: '',
      password: '',
      sending: false,
      showResetPassword: false,
      showForgotPassword: false,
      showForgotPasswordButton: false,
      showDeviceChallenge: false,
      showHelpMessage: false,
      successMessage: '',
      tempPassword: '',
      userCode: '',
      user: {},
      challengeManager: false,
      challengeErrorMessage: null,
      rememberMeFlag: false,
      rememberId: false,
      prTokenSessionValue: sessionStorage.getItem('prtoken')
    };
  }

  static contextType = AppConfigContext;

  componentDidMount() {
    // The logic here is from bfs login, the api team sets redirect token in session with redirectToken Variable and navigates to Premier login
    // In premier UI, we check for the session variable and if it exist just pass that varable to login api .
    // Backend team will use this redirectToken, search for correct username/password  and returns the result by which user will be logged in to dashboard
    // The dummyUser, dummyPassword and dummyCust are passed as login wont alow blank credentials. In this case, these are not required...
    const { sessionValue } = this.props;
    const { prTokenSessionValue } = this.state;
    this.getForgotPasswordOption();
    if (sessionValue) {
      this.setState(
        {
          userCode: dummyUser,
          password: dummyPassword,
          customerCode: dummyCust,
          redirectToken: sessionValue,
          redirectFromBFS: true
        },
        this.login
      );
    } else if (prTokenSessionValue) {
      const prTokenSessionValueObject = JSON.parse(prTokenSessionValue);
      this.setState({
        userCode: prTokenSessionValueObject.userCode,
        customerCode: prTokenSessionValueObject.customerCode,
        password: '',
        showForgotPassword: true,
        redirectFromBFS: true
      });
    }

    const { history } = this.props;
    if (history.location?.state?.message && typeof history.location.state.message === 'string') {
      this.setState({
        errorMessage: history.location.state.message
      });
    }

    getSecureData()
      .then((res) => {
        this.setCredsInState(res.data);
      })
      .catch(() => {
        this.setState({
          rememberIds: false
        });
      });
  }

  componentDidUpdate(previousProps, previousState) {
    const { errorMessage } = this.state;
    if (previousState.errorMessage !== errorMessage && this.state.userCode === dummyUser) {
      this.clearLogin();
    }
  }

  componentWillUnmount() {
    unsubscribeComponent(subscriptions);
  }

  getForgotPasswordOption = () => {
    subscriptions.getSystemOption = getSystemPublicOption({
      optId: SHOW_FORGOT_PASSWORD_OPTION
    }).subscribe(({ data: option, success }) => {
      if (success) {
        this.setState({
          showForgotPasswordButton: Number(option) !== 0
        });
      }
    });
  };

  clearLogin = () => {
    this.setState({
      userCode: '',
      customerCode: '',
      password: ''
    });
  };

  setRememberMe = (checkBox) => {
    this.setState({
      rememberMeFlag: checkBox
    });
  };

  errorHandler = (error = {}) => {
    // destructured below instead of in function parameters for clarity
    const { code, errorGuid, response, userMessage } = error;
    const { locale } = this.props;
    const eCode = response?.data?.[0]?.code || code;
    const guid = errorGuid;
    const message = locale[eCode] || response?.data?.[0]?.userMessage || userMessage || error;

    const errorMessage =
      typeof message === 'string' ? message : this.props.locale['common.server.error'];
    sessionStorage.removeItem('redirecttoken');

    this.setState({
      errorGuid: guid,
      errorMessage,
      showForgotPassword: false,
      sending: false,
      successMessage: '',
      challengeManager: false,
      rememberMeFlag: this.state.rememberMeFlag
    });
  };

  forgotPassword = () => {
    this.setState({
      errorMessage: '',
      showForgotPassword: true,
      successMessage: ''
    });
  };

  clear = (item) => () => this.setState({ [item]: '' });

  close = (item) => () =>
    this.setState({
      [item]: false,
      showDeviceChallenge: false
    });

  open = (item) => () => this.setState({ [item]: true });

  /**
   * @param {Event} event
   * @description This is a Util function React
   * Should probably be moved to a Util/ or Classes/ folder
   * `https://reactjs.org/docs/forms.html#handling-multiple-inputs`
   */
  handleInputChange = (event) => {
    const { target } = event;
    const { name, value } = target;

    // clear unmasked input values
    this.setState({
      [name]: value,
      showForgotPassword: false
    });
  };

  passwordReset = (message) => {
    const successMessage =
      typeof message === 'string' ? message : this.props.locale['common.reset.successful'];
    this.setState({
      errorMessage: '',
      showForgotPassword: false,
      showResetPassword: false,
      successMessage
    });
  };

  login = async (e) => {
    if (e) e.preventDefault();
    const {
      history,
      locale,
      theme: { updateTheme }
    } = this.props;

    const { isNative } = this.context;

    if (isNative && this.state.rememberId) this.storeSecureData();

    if (!this.state.password) {
      this.setState({
        errorMessage: locale.INVALID_USER_PASSWORD,
        successMessage: ''
      });
      return false;
    }

    this.setState({ sending: true });

    try {
      const user = await login({ ...this.state, isNative });
      const challengeType = user.challengeType;
      if (challengeType) this.setState({ challengeType });
      this.checkUserStatus(user);

      // if user is in emulation, we're not redirectings
      // TODO: this wont work when first response is challenged
      if (!user.bankUser) {
        // add excludePathname to bypass withFormPrompt
        // CB-30451
        history.push({
          pathname: WORKSPACES.DASHBOARD,
          state: { excludePathname: WORKSPACES.DASHBOARD }
        });
      }
      updateTheme(user.id);
    } catch (e) {
      jsCookie.remove(HEADERS.X_CM_PASSCODE);
      jsCookie.remove(HEADERS.X_NEXTCM_PASSCODE);
      this.errorHandler(e);
      // delete user credentials on unsuccessful login
      this.removeSecureData();
    }
    // Stops the form from submitting.
    return false;
  };

  checkUserStatus = (user = {}) => {
    // destructured below instead of in function parameters for clarity
    const {
      challeangeable,
      deviceInfoAvailable,
      deviceInfoEnabled,
      deviceInfoPassed,
      errorMessage,
      hideRememberThisDeviceOption,
      isFirstLogin,
      mustChangePassword
    } = user;
    const { password, rememberMeFlag, tempPassword } = this.state;
    const DIcheck = (!deviceInfoPassed && isFirstLogin) || deviceInfoAvailable === false;
    jsCookie.remove(HEADERS.X_CM_PASSCODE);
    jsCookie.remove(HEADERS.X_NEXTCM_PASSCODE);
    if (challeangeable) {
      return this.setState({
        user,
        sending: false,
        challengeManager: true,
        challengeErrorMessage: errorMessage,
        showDeviceChallenge: !hideRememberThisDeviceOption,
        rememberMeFlag
      });
    }
    // ChallengeType comes from login API when OTP or VIP is enabled for login on user
    if (DIcheck && deviceInfoEnabled && !this.state.challengeType) {
      return this.setState({
        user,
        sending: false,
        showDeviceChallenge: true,
        errorMessage: '',
        successMessage: '',
        password: '',
        tempPassword: password,
        rememberMeFlag
      });
    }

    this.setState({ sending: false });
    if (mustChangePassword || isFirstLogin) {
      const { password } = this.state;
      return this.props.setCurrentUser({ ...user, tempPassword: tempPassword || password });
    }
    if (rememberMeFlag) {
      rememberDevice().subscribe();
    }
    return this.props.setCurrentUser(user);
  };

  maskInputField = (value) => {
    const { locale } = this.props;
    const valueArr = value.split('');
    const maskedValue = valueArr.map((str, index) => {
      if (index < 4) {
        return str;
      }

      return locale['common.maskCharacter'];
    });
    return maskedValue.join('');
  };

  setCredsInState = ({ customerCode, userCode }) => {
    this.setState({
      showMaskedInputs: customerCode && userCode,
      customerCode,
      userCode,
      rememberId: true
    });
    this.passwordRef.current.focus();
  };

  storeSecureData = () => {
    const secureData = {
      customerCode: this.state.customerCode,
      userCode: this.state.userCode
    };

    setSecureData(secureData)
      .then((result) => result)
      .catch((err) => err);
  };

  removeSecureData = () => {
    this.setState({
      rememberId: false,
      showMaskedInputs: false,
      password: ''
    });
    // fix this so that only the ID information is deleted
    getSecureData()
      .then((res) => {
        setSecureData({
          ...res.data,
          customerCode: null,
          userCode: null
        }).catch((err) => err);
      })
      .catch(() => {
        setSecureData({}).catch((err) => err);
      });
  };

  unlockMaskedInputs = () => {
    this.setState({
      showMaskedInputs: false
    });
    if (this.context.isNative) this.removeSecureData();
  };

  onRememberIds = (name, value) => {
    this.setState({ rememberId: value }, () => {
      if (!value && this.state.showMaskedInputs) {
        this.removeSecureData();
      }
    });
  };

  render() {
    const {
      className,
      classes: {
        buttonLink,
        formLabel,
        loginForm,
        sessionValue,
        successAlert,
        switchLabel,
        switchMain,
        switchState
      },
      locale
    } = this.props;
    const {
      challengeErrorMessage,
      challengeManager,
      customerCode,
      errorMessage,
      password,
      rememberMeFlag,
      sending,
      showDeviceChallenge,
      showForgotPassword,
      showForgotPasswordButton,
      showHelpMessage,
      showMaskedInputs,
      successMessage,
      userCode
    } = this.state;

    const { isNative, isWeb } = this.context;
    const user = {
      userCode,
      customerCode
    };

    if (showDeviceChallenge && !challengeManager) {
      /** @description
       * This has to be placed here instead of Bootstrap,
       * because we need to optionally remember the device. */
      return (
        <DeviceChallenge
          user={this.state.user}
          onCancel={this.close('showDeviceChallenge')}
          onSuccess={this.checkUserStatus}
        />
      );
    }
    if (challengeManager) {
      return (
        <ChallengeManager
          onCancel={this.close('challengeManager')}
          onHide={this.close('challengeManager')}
          onSuccess={this.checkUserStatus}
          data={this.state.user}
          onSubmit={this.login}
          challengeErrorMessage={challengeErrorMessage}
          open
          deviceChallenge={showDeviceChallenge}
          rememberMe={this.setRememberMe}
          rememberMeFlag={rememberMeFlag}
        />
      );
    }
    if (sessionValue && !errorMessage) {
      return null;
    }
    const showAlert = errorMessage || successMessage;
    const alertVariant = errorMessage ? ALERTVARIATIONS.ERROR : ALERTVARIATIONS.SUCCESS;
    return (
      <div>
        <form
          name="PassForm"
          className={classnames(className, loginForm)}
          autoComplete="off"
          onSubmit={this.login}
        >
          {showAlert && (
            <Alert
              className={successAlert}
              variant={alertVariant}
              id={errorMessage ? 'loginFormError' : 'loginFormSuccess'}
              dataQa={`${alertVariant}-alert`}
              onHide={errorMessage ? this.clear('errorMessage') : this.clear('successMessage')}
              suppressIcon={!!successMessage}
            >
              {errorMessage && errorMessage}
              {successMessage && successMessage}
            </Alert>
          )}
          <fieldset>
            <legend className="sr-only">{locale.logInTitle}</legend>
            <div className="form-group">
              <label className={formLabel} htmlFor="a11y-realm">
                {locale['logon.prompt.usergroup']}
                {/* If there is no masked code then assume user is entering/editing creds
                and or rememberId is not checked so hide input */}
                {!showMaskedInputs && (
                  <input
                    aria-required="true"
                    autoCorrect="off"
                    className="form-control"
                    disabled={sending}
                    id="a11y-realm"
                    data-qa="a11y-realm"
                    name="customerCode"
                    onChange={this.handleInputChange}
                    type="text"
                    value={customerCode}
                  />
                )}
                {showMaskedInputs && (
                  <input
                    type="text"
                    defaultValue={this.maskInputField(customerCode)}
                    name="maskedCustomerCode"
                    className="form-control"
                    onClick={this.unlockMaskedInputs}
                  />
                )}
              </label>
              <span className="help-block" />
            </div>

            <div className="form-group">
              <label className={formLabel} htmlFor="a11y-username">
                {locale['logon.prompt.userCode']}
                {!showMaskedInputs && (
                  <input
                    aria-required="true"
                    autoCorrect="off"
                    className="form-control"
                    disabled={sending}
                    id="a11y-username"
                    name="userCode"
                    onChange={this.handleInputChange}
                    type="text"
                    value={userCode}
                    data-qa="a11y-username"
                  />
                )}
                {showMaskedInputs && (
                  <input
                    type="text"
                    defaultValue={this.maskInputField(userCode)}
                    name="maskedUserCode"
                    className="form-control"
                    onClick={this.unlockMaskedInputs}
                  />
                )}
              </label>
              <span className="help-block" />
            </div>

            <div className="form-group">
              <label className={formLabel} htmlFor="a11y-password">
                {locale['logon.prompt.password']}
                <input
                  ref={this.passwordRef}
                  aria-required="true"
                  className="form-control"
                  disabled={sending}
                  id="a11y-password"
                  name="password"
                  onChange={this.handleInputChange}
                  type="password"
                  value={password}
                  data-qa="a11y-password"
                />
              </label>
              <span className="help-block" />
            </div>
            {isNative && (
              <div className="form-group">
                <Switch
                  classes={{
                    switch: switchMain,
                    switchLabel,
                    switchState
                  }}
                  name="rememberIds"
                  onChange={this.onRememberIds}
                  value={this.state.rememberId}
                  labelText={locale['logon.prompt.rememberIds']}
                  disabled={!this.state.customerCode && !this.state.userCode}
                />
              </div>
            )}
            <div className="form-group">
              <button
                className="btn btn-primary"
                disabled={sending}
                id="login-action-submit"
                type="submit"
              >
                <span>{sending ? locale['common.submitting'] : locale['button.signIn']}</span>
              </button>

              {!showHelpMessage && showForgotPasswordButton && (
                <button
                  className={`btn btn-tertiary pull-right ${buttonLink}`}
                  disabled={sending}
                  onClick={this.open('showForgotPassword')}
                  type="button"
                  data-qa="forgot-password"
                >
                  {locale['common.forgotPassword']}
                </button>
              )}
            </div>
          </fieldset>

          {showHelpMessage && showForgotPasswordButton && (
            <button
              data-qa="forgot-password"
              className={`btn btn-link ${buttonLink}`}
              disabled={sending}
              onClick={this.open('showForgotPassword')}
              type="button"
            >
              {locale['common.forgotPassword']}
            </button>
          )}

          {isWeb && (
            <LoginHelpMessage
              className={buttonLink}
              locale={locale}
              onContent={this.open('showHelpMessage')}
            />
          )}
        </form>

        {/** @description This needs to access { userCode, customerCode }. Cannot nest forms. */}
        <Modal
          show={showForgotPassword}
          transition={Slide}
          onHide={this.close('showForgotPassword')}
          header={locale['common.security.title']}
        >
          {showForgotPassword && (
            <SecurityChallenge
              onSuccess={this.passwordReset}
              onError={this.errorHandler}
              user={user}
              locale={locale}
            />
          )}
        </Modal>
      </div>
    );
  }
}

LoginFormComponent.propTypes = {
  locale: LocaleShape,
  setCurrentUser: PropTypes.func.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  sessionValue: PropTypes.string,
  theme: PropTypes.shape({})
};

LoginFormComponent.defaultProps = {
  locale: LocaleDefaultProps,
  className: '',
  classes: {},
  history: {},
  sessionValue: null,
  theme: {}
};
const mapDispatchToProps = { setCurrentUser };

const LoginFormStyled = withStyles(styles)(LoginFormComponent);
const Themed = withTheme(LoginFormStyled);
const Routed = withRouter(Themed);
export default connect(null, mapDispatchToProps)(Routed);
